// Browser-specific exports that exclude Node.js-only modules
export * from "./filehandle.js";
export { default as BlobFile } from "./blobFile.js";
export { default as RemoteFile } from "./remoteFile.js";
export class LocalFile {
    readFile() {
        throw new Error('unimplemented');
    }
    read() {
        throw new Error('unimplemented');
    }
    close() {
        throw new Error('unimplemented');
    }
}
//# sourceMappingURL=browser.js.map